var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElasticStack6802Dde19Bb7822E69C5A4F83027B57A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none}.st1,.st2,.st3,.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#eb0d72}.st2,.st3,.st4{fill:#00a9e5}.st3,.st4{fill:#fed10a}.st4{fill:#3ebeb0}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h80v80H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11 16.5c0-3.6 2.9-6.5 6.5-6.5h45.1c3.6 0 6.5 2.9 6.5 6.5V29H11V16.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11 51h27.8v19H17.3c-3.5 0-6.3-2.9-6.3-6.5V51z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.2 51H69v12.5c0 3.6-2.8 6.5-6.3 6.5H41.2V51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11 31h58v18H11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticStack6802Dde19Bb7822E69C5A4F83027B57A);
export default __webpack_public_path__ + "static/media/elastic-stack.6802dde19bb7822e69c5a4f83027b57a.6802dde19bb7822e69c5a4f83027b57a.svg";
export { ForwardRef as ReactComponent };